<template>
  <div v-if="currentUser" class="biz-calendar-page">
    <div class="page-header">
      <h1>Kalendarz</h1>
    </div>

    <div class="section-card intro-card">
      <div class="section-card-header">
        <h2>Konfiguracja kalendarza usług</h2>
        <p class="section-subtitle">Wybierz usługę, aby przejść do podglądu lub edycji kalendarza.</p>
      </div>
    </div>

    <div class="section-card" v-if="myServices && employees">
      <ServiceModal />

      <div class="table-wrap">
        <table class="services-table">
          <thead>
          <tr>
            <th>Nazwa usługi</th>
            <th>Pracownik</th>
            <th>Akcje</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="service in myServices" :key="service.service.id">
            <td>{{ service.service.name }}</td>
            <td>
              {{
                service.service.employee_id
                    ? `${employees.filter(item => item.id == service.service.employee_id)[0].firstname} ${employees.filter(item => item.id == service.service.employee_id)[0].lastname}`
                    : 'brak pracownika'
              }}
            </td>
            <td class="actions">
              <button
                  class="btn-icon"
                  title="Podgląd usługi"
                  @click="() => $router.push({ path: `/dla-biznesu/profile/calendar`, query: { serviceID: service.service.id } })"
              >
                <img src="@/assets/icons/eye-fill.svg" alt="podgląd usługi">
              </button>
              <button
                  class="btn-icon btn-primary-icon"
                  title="Edytuj kalendarz"
                  @click="() => $router.push({ path: `/dla-biznesu/profile/calendar/${service.service.id}` })"
              >
                <img src="@/assets/icons/calendar-date.svg" alt="wybierz">
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="section-card" v-else>
      <div class="empty-state">
        <p>Ładowanie danych kalendarza...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import axios from 'axios';
import authHeader from '@/services/auth-header';
import ServiceModal from '@/components/SpecialComponents/ServiceModal.vue';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'BizProfileCalendarVue',
  components: { ServiceModal },
  setup() {
    useMeta({ title: 'Kalendarz' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      myServices: null,
      employees: null,
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 2) {
      this.$router.push('/login');
    }

    if (this.appStore.isSubscribed) {
      this.getMyServices();
      this.getEmployees();
    } else {
      this.$router.push('/dla-biznesu/profile/user-data');
    }
  },
  methods: {
    getMyServices() {
      axios.get(`/UserService/${this.currentUser.id}`).then(res => {
        this.myServices = res.data;
      });
    },
    getEmployees() {
      axios.post(`/Users`, { main_id: this.currentUser.id, page: 1, limit: 100 }, authHeader())
          .then(res => {
            this.employees = res.data.items;
          }).catch(() => {});
    },
  },
};
</script>

<style scoped lang='scss'>
.biz-calendar-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
}

.section-card {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.section-card-header {
  margin-bottom: 10px;
}

.section-card-header h2 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
  font-weight: 700;
}

.section-subtitle {
  margin: 8px 0 0 0;
  color: #666;
  font-size: 1.4rem;
}

.table-wrap {
  width: 100%;
  overflow-x: auto;
}

.services-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 720px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.services-table thead th {
  background: #f9fafb;
  color: #374151;
  font-size: 1.4rem;
  font-weight: 700;
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.services-table tbody td {
  padding: 12px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 1.4rem;
  color: #1f2937;
  vertical-align: middle;
}

.services-table tbody tr:last-child td {
  border-bottom: none;
}

.services-table tbody tr:hover td {
  background: #fcfcfd;
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-icon {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .2s ease-in-out;
}

.btn-icon img {
  width: 18px;
  height: 18px;
}

.btn-icon:hover {
  border-color: #10b981;
  transform: translateY(-1px);
}

.btn-primary-icon {
  background: #f2790f;
  border-color: #f2790f;
}

.btn-primary-icon img {
  filter: brightness(0) invert(1);
}

.btn-primary-icon:hover {
  background: #d66a0a;
  border-color: #d66a0a;
}

.empty-state {
  text-align: center;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  padding: 24px;
}

@media (max-width: 768px) {
  .section-card {
    padding: 16px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card-header h2 {
    font-size: 1.8rem;
  }
}
</style>